// bluaIQ — CSV Export Utility
// Generates and downloads CSV files from any data array.
// Works entirely in the browser — no server needed.

interface ExportOptions {
  filename: string
  headers: string[]
  rows: (string | number | null | undefined)[][]
}

export function downloadCsv({ filename, headers, rows }: ExportOptions) {
  const escape = (val: string | number | null | undefined): string => {
    if (val == null) return ''
    const str = String(val)
    // Escape quotes and wrap in quotes if contains comma, quote, or newline
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`
    }
    return str
  }

  const csvContent = [
    headers.map(escape).join(','),
    ...rows.map(row => row.map(escape).join(','))
  ].join('\n')

  // Add BOM for Excel to recognize UTF-8
  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = `${filename}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
